var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "104.2%",
    height: "101.7%",
    x: "-2.1%",
    y: "-.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.823529412 0 0 0 0 0.823529412 0 0 0 0 0.823529412 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "102.5%",
    height: "102.5%",
    x: "-1.2%",
    y: "-1.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.823529412 0 0 0 0 0.823529412 0 0 0 0 0.823529412 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#b)",
    transform: "translate(-15 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M15 15h210v210H15z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.75 66.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.71,
    cy: 51.71,
    r: 13.406,
    fill: "#D8D8D8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M38.495 7.66l-8.06 8.938H16.47c-4.846 0-8.81 4.022-8.81 8.938V79.16c0 4.915 3.964 8.937 8.81 8.937h70.478c4.846 0 8.81-4.022 8.81-8.937V25.536c0-4.916-3.964-8.938-8.81-8.938H72.986l-8.061-8.937h-26.43zM51.71 74.693c-12.158 0-22.025-10.01-22.025-22.344 0-12.334 9.867-22.344 22.025-22.344 12.157 0 22.024 10.01 22.024 22.344 0 12.334-9.867 22.344-22.024 22.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h107.25v107.25H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.8a077025656d0c6266a60739dd52cbd8.svg";
export { ForwardRef as ReactComponent };